import React, { useState } from 'react'
import styled from 'styled-components'
import OutsideClickHandler from 'react-outside-click-handler'
import { TopNavLink, TopNavLinkStyle } from './TopNavLink'
import { TopNavColor } from './TopNav.types'
import { STYLES } from '../../static/style'
import { CaretDownIcon } from '../../components/Icon/CaretDownIcon'

type TopNavDropdownLinkItem = {
  to: string
  text: string
}

type TopNavDropdownProps = {
  className?: string
  title: string
  color: TopNavColor
  items: Array<TopNavDropdownLinkItem>
}

const StyledTopNavDropdown = styled(TopNavLink)`
  ${TopNavLinkStyle};
  position: relative;
`

const TopNavDropdownMenu = styled.div`
  position: absolute;
  background-color: ${STYLES.COLOR_WHITE};
  top: 2.4rem;
  padding: 1rem 0;
  left: 0;
  box-shadow: 1px 1px 2px #888, -1px 1px 2px #888;
  z-index: 50;
`

const StyledTopNavLink = styled(TopNavLink)`
  display: block;
  padding: 1rem 2rem;
  color: ${STYLES.COLOR_BLACK};
  white-space: nowrap;
  text-align: left;
  &:hover {
    color: ${STYLES.PRIMARY_COLOR};
    text-decoration: none;
  }
`

const TopNavDropdownText = styled.div`
  display: flex;
  align-items: center;
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

export const TopNavDropdown = ({
  className,
  color = TopNavColor.NORMAL,
  title,
  items,
}: TopNavDropdownProps) => {
  const [isShowMenu, setIsShowMenu] = useState<boolean>(false)
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsShowMenu(false)
      }}
    >
      <StyledTopNavDropdown
        color={color}
        className={className}
        onClick={() => setIsShowMenu(!isShowMenu)}
      >
        <TopNavDropdownText>
          {title}&nbsp;
          <CaretDownIcon />{' '}
        </TopNavDropdownText>
        {isShowMenu && (
          <TopNavDropdownMenu>
            {items.map((i) => (
              <StyledTopNavLink key={i.to} to={i.to}>
                {i.text}
              </StyledTopNavLink>
            ))}
          </TopNavDropdownMenu>
        )}
      </StyledTopNavDropdown>
    </OutsideClickHandler>
  )
}
